<template>
    <div class="content-page">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="d-flex flex-wrap align-items-center justify-content-between mb-4">
                        <div>
                            <h4 class="mb-3">Liste des entreprises</h4>
                        </div>
                        <a href="/create-entreprise"  class="btn btn-primary add-list" ><i class="las la-plus mr-3"></i>Ajouter un utilisateur</a>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="table-responsive rounded mb-3">
                        <table id="example" class="data-table table mb-0 tbl-server-info">
                            <thead class="bg-white text-uppercase">
                                <tr class="ligth ligth-data">
                                    <th>Entreprise</th>
                                    <th>Administrateur</th>
                                    <th>Email</th>
                                    <th >Actions</th>
                                </tr>
                            </thead>
                            <tbody class="ligth-body">
                                <tr v-for="(type,index) in types" :key="index">
                                    <td>{{type.name}}</td>
                                    <td v-if="type.user[0]">{{type.user[0].nom}} {{type.user[0].prenoms}} </td> 
                                    <td v-else>pas d'administrateur</td>
                                    <td v-if="type.user[0]">{{type.user[0].email}} </td> 
                                    <td v-else>pas de compte rattaché</td>
                                    <td >
                                        <div class="d-flex align-items-center list-action">

                                        <button v-if="type.user[0]"  class="badge badge-info bg-warning mr-2 btn" data-toggle="tooltip" data-placement="top" title="" data-original-title="Delete"
                                            @click="destroy(type.user[0].id)"><i class="fa fa-trash mr-0"></i></button>
                                        <button v-if="type.user[0] && type.user[0].active == 0" type="btn"  class="badge badge-info bg-secondary btn mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Delete"
                                            @click="active(type.user[0].id,1)"><i class="fa fa-lock mr-0"></i></button>
                                        <button v-if="type.user[0] && type.user[0].active == 1" type="btn"  class="badge badge-info bg-secondary btn mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Delete"
                                            @click="active(type.user[0].id,0)"><i class="fa fa-unlock mr-0"></i></button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="vld-parent">
            <loading :active.sync="isLoading" 
            :can-cancel="true" 
            :is-full-page="fullPage"></loading>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import {URL_API} from '@/config'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import Swal from 'sweetalert2'
import $ from "jquery"
export default {
    components: {
            Loading
    },
    data() {
        return {permissions: [],
            isLoading: false,
            fullPage: true,
            types: []
        };
    },
    mounted(){
        this.getTypes()
    },
    methods:{
        getTypes(){
            let app = this
            app.isLoading = true
            axios.get(URL_API+'entreprises')
            .then(function (reponse){
                console.log('reponse', reponse)
                if (reponse.data.status) {
                    $(document).ready( function () {
                            $('#example').DataTable(
                                {
                                    "lengthMenu": [ 5,10, 25, 50, 75, 100 ],
                                    "pageLength": 10,
                                    'order':[],
                                    stateSave: true,
                                    "bDestroy": true
                                }
                            );
                        } );
                    app.types = reponse.data.data
                    app.isLoading = false
                }
                
            })
            .catch(function (error){
                console.log('error', error);
            })
        },
        destroy(id) {
            let app = this
            Swal.fire({
                title: 'Vous vous supprimer ce compte ?',
                text: "Cette action est irreversible!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Oui, supprimer!',
                cancelButtonText: 'annuler'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.isLoading =  true
                    axios.delete(URL_API+'user/'+id)
                    .then(response => {
                        console.log(response)
                        if (response.data.status == true) {
                            this.isLoading =  false
                            Swal.fire(
                                'Supprimé!',
                                'Cet utilisateur a été supprimé avec succès',
                                'success'
                            )
                        app.getTypes()
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        this.errored = true
                        this.isLoading =  false
                    })
                    
                }
            })
            
        },
        active(userID,id) {
            let app = this
            Swal.fire({
                title: 'voulez-vous activer/désactiver ce compte?',
                text: "Cette action est irréversible!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Oui!',
                cancelButtonText: 'annuler'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.isLoading =  true
                    axios.post(URL_API+'active-disable',{
                        user_id:userID,
                        active:id
                    })
                    .then(response => {
                        console.log(response.data)
                        this.isLoading =  false
                        if (id == 0) {
                            Swal.fire(
                                'Succès !',
                                'Compte desactivé',
                                'success'
                            )
                        } else {
                            Swal.fire(
                                'Succès !',
                                'Compte activé',
                                'success'
                            )
                        }
                        
                        app.getTypes()
                    })
                    .catch(error => {
                        console.log(error)
                        this.errored = true
                        this.isLoading =  false
                    })
                }
            })
            
        },
    }
}
</script>